import { render, staticRenderFns } from "./bloodPressure.vue?vue&type=template&id=63e7b61b&scoped=true"
import script from "./bloodPressure.vue?vue&type=script&lang=js"
export * from "./bloodPressure.vue?vue&type=script&lang=js"
import style0 from "./bloodPressure.vue?vue&type=style&index=0&id=63e7b61b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e7b61b",
  null
  
)

export default component.exports